// UNPROTECTED PATHS
export const LANDING_SCREEN = "/welcome";
export const LOGIN = "/login";
export const CREATE_ACCOUNT = "/create-account";
export const PASSWORD_RECOVERY = "/password-recovery";
export const RECOVERY_LINK_SENT = "/recovery-success";
export const RESET_PASSWORD = "/new-password";
export const RESET_PASSWORD_SUCCESS = "/reset-success";

// PROTECTED PATHS
export const APP_HOME = "/home";
export const SOLUTIONS_HOME = "/solutions";
export const CREATE_BUILDING = "/admin/buildings/new";
export const EDIT_BUILDING = "/admin/buildings/edit";
export const CREATE_ENVIRONMENT = "/admin/automation/environments/new";
export const CREATE_AC = "/admin/automation/equipment/new";
export const CREATE_ELECTRICAL_PANEL = "/admin/automation/capacity/";
export const CREATE_LIGHTS = "/admin/automation/lights";
export const CREATE_REFRIGERATION = "/admin/automation/refrigeration";
export const CREATE_ENGINES = "/admin/automation/engines";
export const CREATE_HEATING_WATER = "/admin/automation/heating-water";
export const CREATE_OTHER_CARGO = "/admin/automation/other-cargo";
export const CONFIGURE_IR = "/solutions/devices/configure-ir";
export const GREEN_ENERGY_CONTRACT = "/solutions/green-energy-contracts";
export const CREATE_INSTALATION = "/admin/buildings/installation/new";
export const EDIT_INSTALATION = "/admin/buildings/installation/edit";
export const CREATE_ROUTER = "/admin/automation/router";
export const CREATE_ROUTER_MANUAL = "/admin/automation/router-manual";
export const CREATE_PHOTOVOLTAIC = "/admin/automation/photovoltaic";
export const CREATE_BLOCKS = "/admin/buildings/blocks-pavements";
